import { initializeApp } from "firebase/app";
import { getMessaging, onMessage, isSupported } from "firebase/messaging";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";

// jayarams firebase creds

// const firebaseConfig = {
//   apiKey: "AIzaSyAky-TifZBScd8eOqwlcuy4nMmyfy9tkk4",
//   authDomain: "testing-poc-6b022.firebaseapp.com",
//   projectId: "testing-poc-6b022",
//   storageBucket: "testing-poc-6b022.appspot.com",
//   messagingSenderId: "233296064346",
//   appId: "1:233296064346:web:4eff615f6fd2ee6067cd63",
//   measurementId: "G-1J0BMZMJEV",
// };

// niyama firebase creds

const firebaseConfig = {
  apiKey: "AIzaSyAyWN6Q0Yv4fHoIPBgD-8E1aNAZPQijouY",
  authDomain: "niyama-e72a3.firebaseapp.com",
  projectId: "niyama-e72a3",
  storageBucket: "niyama-e72a3.appspot.com",
  messagingSenderId: "93958639689",
  appId: "1:93958639689:web:5542a0557483af4585af98",
  measurementId: "G-ER9CRL7DWL",
};

export const app = initializeApp(firebaseConfig);
// Web push needs service workers and the Push API, which iPhone browser tabs, in-app browsers and
// private windows don't have - getMessaging() there throws an uncaught "messaging/unsupported-browser".
// Resolves to the messaging instance, or null where push isn't supported.
export const messagingPromise = isSupported()
  .then((supported) => (supported ? getMessaging(app) : null))
  .catch(() => null);
export const db = getFirestore(app);
export const rdb = getDatabase(app);

export const onMessageListener = () =>
  new Promise((resolve) => {
    messagingPromise.then((messaging) => {
      if (!messaging) return;
      onMessage(messaging, (payload) => {
        // console.log("payload", payload)
        resolve(payload);
      });
    });
  });
